/**
 * SifreLinkiModal.jsx — Kullanıcı Kartı › "Şifre bağlantısı oluştur" sonucu (backlog #556, backend #555).
 *
 * `POST /users/{id}/sifre-linki` anahtarı YALNIZCA bir kez döner (backend yalnızca SHA-256'sını tutar), bu yüzden bağlantı yalnızca
 * bu pencerenin state'inde yaşar: sayfa `sifreLinki` null olunca pencere kapanır ve anahtar gider; ne localStorage'a yazılır ne
 * konsola basılır. Bu pencere bağlantıyı personele gösterir (kopyalayıp elle iletmek için); bağlantıyı kullanıcının e-postasına gönderen yol ayrı:
 * Kullanıcı Kartı › "Aktivasyon maili gönder" (#568 / #572), orada bağlantı personele hiç gösterilmez.
 *
 * Pencere bağlantının tamamını (`<köken>/sifre-belirle?anahtar=…`), Kopyala düğmesini, bitiş tarihini (7 gün), yeni bağlantının
 * öncekini iptal ettiğini ve (giriş pasifse) şifrenin girişi etkinleştirmediğini söyler.
 */
import React, { useState } from "react";
import { Alert, Button, Input, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Check, Copy } from "lucide-react";
import { useTranslation } from "react-i18next";
import { sifreBelirleAdresi } from "../../../../services/sifreBelirleService";
import { tarihSaat } from "../../../../Components/Kullanici/KullaniciParcalari";

export default function SifreLinkiModal({ sifreLinki, onClose }) {
  const { t } = useTranslation("yonetim");
  const [kopyalandi, setKopyalandi] = useState(false);
  const adres = sifreBelirleAdresi(sifreLinki.anahtar);

  async function kopyala() {
    try {
      await navigator.clipboard.writeText(adres);
      setKopyalandi(true);
      setTimeout(() => setKopyalandi(false), 2000);
    } catch {
      // Pano kapalıysa sessizce geç: adres alanda seçili, elle kopyalanır.
    }
  }

  return (
    <Modal isOpen toggle={onClose} centered>
      <ModalHeader toggle={onClose}>{t("sifreLinkiModal.baslik")}</ModalHeader>
      <ModalBody>
        <p className="small mb-2">
          {t("sifreLinkiModal.aciklama", { ad: sifreLinki.kullaniciAdi })}
        </p>
        <InputGroup size="sm" className="mb-2">
          <Input
            readOnly value={adres} className="font-monospace" aria-label={t("sifreLinkiModal.baglanti")}
            onFocus={(e) => e.target.select()}
          />
          <Button color={kopyalandi ? "secondary" : "primary"} onClick={kopyala}>
            {kopyalandi
              ? <><Check size={13} className="me-1" />{t("sifreLinkiModal.kopyalandi")}</>
              : <><Copy size={13} className="me-1" />{t("sifreLinkiModal.kopyala")}</>}
          </Button>
        </InputGroup>
        <ul className="small text-muted ps-3 mb-2">
          <li>{t("sifreLinkiModal.gecerlilik", { gun: sifreLinki.gecerlilikGun, tarih: tarihSaat(sifreLinki.gecerlilikBitis) })}</li>
          <li>{t("sifreLinkiModal.birKezKullanilir")}</li>
          <li>{t("sifreLinkiModal.oncekiIptal")}</li>
          <li>{t("sifreLinkiModal.birKezGosterilir")}</li>
        </ul>
        {sifreLinki.kullaniciAktif === false && (
          <Alert color="warning" fade={false} className="small mb-0">{t("sifreLinkiModal.pasifUyarisi")}</Alert>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onClose}>{t("common:kapat")}</Button>
      </ModalFooter>
    </Modal>
  );
}
